import * as THREE from 'three';
import { VanState, templateById } from '../vans/vans';

/**
 * Van-Hintergrund: Boden, Wände, Decke und Radkästen als Referenzgeometrie.
 * Nicht auswählbar/pickbar (eigenes Group ohne userData.faceId).
 */
export class VanRenderer {
  group = new THREE.Group();

  update(state: VanState): void {
    this.group.clear();
    if (!state.visible) return;

    const L = state.length;
    const W = state.width;
    const H = state.height;
    const wallMat = new THREE.MeshLambertMaterial({
      color: 0xaab2ba,
      transparent: true,
      opacity: 0.35,
      side: THREE.DoubleSide,
      depthWrite: false
    });
    const floorMat = new THREE.MeshLambertMaterial({ color: 0x9aa2a9, side: THREE.DoubleSide });

    const addPlane = (w: number, h: number, pos: [number, number, number], rot: [number, number, number], mat: THREE.Material) => {
      const geo = new THREE.PlaneGeometry(w, h);
      const mesh = new THREE.Mesh(geo, mat);
      mesh.position.set(...pos);
      mesh.rotation.set(...rot);
      this.group.add(mesh);
    };

    // Boden
    addPlane(L, W, [0, 0, 0.001], [0, 0, 0], floorMat);
    // Decke
    addPlane(L, W, [0, 0, H], [Math.PI, 0, 0], wallMat);
    // Wände: links (y-), rechts (y+), Heck (x-), Fahrerhaus-Trennwand (x+)
    addPlane(L, H, [0, -W / 2, H / 2], [-Math.PI / 2, 0, 0], wallMat);
    addPlane(L, H, [0, W / 2, H / 2], [Math.PI / 2, 0, 0], wallMat);
    addPlane(W, H, [-L / 2, 0, H / 2], [0, Math.PI / 2, 0], wallMat);
    addPlane(W, H, [L / 2, 0, H / 2], [0, -Math.PI / 2, 0], wallMat);

    // Konturlinien des Hohlraums
    const box = new THREE.BoxGeometry(L, W, H);
    const edges = new THREE.EdgesGeometry(box);
    const line = new THREE.LineSegments(edges, new THREE.LineBasicMaterial({ color: 0x7d868e }));
    line.position.set(0, 0, H / 2);
    this.group.add(line);

    // Radkästen + Räder
    const arch = templateArch(state);
    if (state.arches && arch) {
      const archMat = new THREE.MeshLambertMaterial({ color: 0x8f979e });
      const archGeo = new THREE.BoxGeometry(arch.length, arch.thickness, arch.height);
      for (const side of [-1, 1]) {
        const mesh = new THREE.Mesh(archGeo, archMat);
        mesh.position.set(-L / 2 + arch.fromRear + arch.length / 2, side * (W / 2 - arch.thickness / 2), arch.height / 2);
        this.group.add(mesh);
      }
    }
  }
}

function templateArch(state: VanState): { length: number; thickness: number; height: number; fromRear: number } | null {
  const t = templateById(state.templateId);
  if (!t.wheelArch) return null;
  const thickness = Math.max(0.05, (state.width - t.wheelArch.clearance) / 2);
  return { length: t.wheelArch.length, thickness, height: t.wheelArch.height, fromRear: t.wheelArch.fromRear };
}
